import React,{useEffect, useState} from 'react';
import {NavLink, Link, useLocation} from 'react-router-dom';
import { BsSquare } from "react-icons/bs";
import styled from  '@emotion/styled';
import {FiChevronDown } from "react-icons/fi";
import {Shops
  ,Products
  ,Orders
  ,Returned
  ,Supplements
  ,Reports
  ,Contracts 
  ,Regions
  ,Messages} from "./SideMenuIcons"

const Svg ={
   Shops:Shops
  ,Products:Products
  ,Orders:Orders
  ,Returned:Returned
  ,Supplements:Supplements
  ,Reports:Reports
  ,Contracts:Contracts 
  ,Regions:Regions
  ,Messages:Messages
}


const SubMenu = styled.div`

.sub__menus {
  max-height: 0;
    opacity:0;
    transition: all 500ms ;
    overflow: hidden;
}

.sub__menus__Active {
  opacity:1;
  max-height: 500px;
    transition:all 1000ms ;
}
`;
const SubMenuTitle = styled.div`
position:relative;
&:hover {
color: none;
color:white;
background: rgb(1,166,244);
}
cursor: pointer;
${({ isActive }) =>
isActive &&
`
&::before{
  content:"";
  margin:0;
  position:absolute;
  right:0;
  background: #1811B7;
  width:7px;
  height:100%;
  border-radius:20px 0px 0 20px;
}

  
`}

color:var(--black-and-white);
box-sizing:border-box;
border-radius:10px;
text-decoration: none;
display: flex;
align-items: center;
justify-content: ${props => (props.actives==="false" ? "space-around" : "flex-start")};
li a{
  width:124%;
}
`;
const StyledNavLink = styled(NavLink)`
--color : var(--black-and-white);
/* transition: all 300ms; */
background-color: transparent;
width:100%;
border-radius:10px;
text-decoration: none;
display: flex;
align-items: center;

&:link {
color: var(--color);
}

&:visited {
color: var(--color);
}

/* mouse over link */
&:hover {
color: none;
color:white;
background: rgb(1,166,244);
}

/* selected link */
&:active {
color: none;
}
&:focus{
  outline:none
}
 &.active {
   svg{
    color:white !important;

   }
     color:white;
     background: rgb(1,166,244);
     background: linear-gradient(90deg, rgba(1,166,244,1) 0%, rgba(9,9,121,1) 100%);
     width:100%;
    border-radius:10px;
  }

`;
const ItemContainer = styled.div`

display:block;

`;
const IconContainer = styled.div`
  box-sizing:border-box;
  margin:2.5% 20% 2.5% 10%;
  display:flex;
  align-items:center;
  justify-content:center;
  width:27px;
  height:27px;
`


const NavbarmenuItem = (props) => {


  const location = useLocation();
  const [isMenu, setisMenu] = useState(false);
  const [isResponsiveclose, setResponsiveclose] = useState(false);
  const toggleClass = () => {
    setisMenu(isMenu === false ? true : false);
    setResponsiveclose(isResponsiveclose === false ? true : false);
};
  const [isMenuSubMenu, setMenuSubMenu] = useState(false);
  const toggleSubmenu = () => {
    setMenuSubMenu(isMenuSubMenu === false ? true : false);
  };
  let boxClassSubMenu = ["sub__menus"];
  if(props.submenuStates) {
      boxClassSubMenu.push('sub__menus__Active');
  }else {
      boxClassSubMenu.push('');
  }

  if(props.menu.type ==="multiple"){
    let active = false;
    for(let key of props.menu.content){
      if(key.link === location.pathname)
      active=true;
    }

    return (
      <ItemContainer>
              <SubMenu className='multiple' >
                <ItemContainer > 
                <SubMenuTitle className='menu-link' isActive={active} onClick={()=>props.submenuFunction(props.id)} >

                          <div className='menu-text'>{props.menu.title}</div>
                </SubMenuTitle>
                </ItemContainer>
        <div className={boxClassSubMenu.join(' ')} > 
            {props.menu.content.map(submenu=>{
                return   <div onClick={()=>{props.onClick();toggleSubmenu()}} key={props.menu.content.indexOf(submenu)}>
                  <StyledNavLink activeclassname='is-active'  to={submenu.link}>
                    <div className='submenu-text'>{submenu.title}</div>
                     </StyledNavLink> 
                     </div>
  
            })}
        </div>
      </SubMenu>
      </ItemContainer>
    )
  }
  

    if(props.menu.type ==="single") {

      return (
       <ItemContainer  onClick={props.onClick} className="menu-item" >

       <StyledNavLink className="menu-link"  onClick={toggleSubmenu}   actives={props.actives.toString()}   exact="true" activeclassname='is-active' to={props.menu.link}>

                   <div className='menu-text'>{props.menu.title}</div>
       </StyledNavLink> 
       </ItemContainer>
      )

    }


}

export default NavbarmenuItem
